import ComponentBasePrototype from 'ComponentBasePrototype';
import _ from 'lodash';
import $ from 'jquery';
import Autocomplete from '../../../base/ui/autocomplete/autocomplete';
import { sendEventToGoogleAnalytics } from '../../../base/analytics/analyticsEvents';
import Cookies from 'cookies';

export default class AvailabilitySearch extends ComponentBasePrototype {
  getRequiredModules() {
    return ['metrics'];
  }

  build() {
    this.isNumber = /^\d+$/;
    this.eshopForm = this.node.find('#eshopform');
    this.eshopFormPostalCode = this.node.find('#eshopform__postal-code');
    this.eshopFormStreetName = this.node.find('#eshopform__street-name');
    this.eshopFormStreetNumber = this.node.find('#eshopform__street-number');
    this.eshopFormApartment = this.node.find('#eshopform__apartment');
    this.postalCodeInput = this.node.find('.availabilitysearch__postalcode-input');
    this.streetInput = this.node.find('.availabilitysearch__street-input');
    this.inputs = this.node.find('.text-input__field');
    this.submitButton = this.node.find('.availabilitysearch__submit');
    this.errorMsg = this.node.find('.availabilitysearch__error--address');
    this.generalErrorMsg = this.node.find('.availabilitysearch__error--general');
    this.inputErrorClass = 'has-error';
    this.postalCodeInputErrorMsgClass = this.node.find('.text-input__error-text--postalcode');
    this.streetInptErrorMsgClass = this.node.find('.text-input__error-text--street');
    this.streetDropdownMismatchErrorMsgClass = this.node.find('.text-input__error-text--street-dropdown-mismatch');
    this.entireAddressErrorMsgClass = this.node.find('.text-input__error-text--entire-address');
    this.inputPostalOkClass = this.node.find('.availabilitysearch__postalcode-input--icon-ok');
    this.inputStreetOkClass = this.node.find('.availabilitysearch__street-input--icon-ok');
    this.loadingAnimation = this.node.find('.component-loader__wrapper');
    this.loadingAnimationVisibleClass = 'component-loader__wrapper--active';
    this.validatedPostalCode = null;
    this.activeSuggestion = -1;
    this.amountSuggestions = 0;
    this.resolvingPostalcode = false;
    this.matchStreetNumbers = [];
    this.cookieName = 'availability';
    this.debounceValidation = this.getDebounceValidateAddressFunction();
    this.stillValidating = false;
    this.successParameterSentToAnalytics = null;
    this.streetErrorTimerId = null;

    this.bindEventListeners();
    this.bindAutocomplete();
    this.populateDataFromCookie();
    this.disableSubmitButtonWhenStreetChanged();
    this.hideValidCheckmarkWhenStreetChanged();
    this.validateAddressWhenTyping();
    this.moveToNextFocusableElementFromStreetInputField();

    return true;
  }

  disableSubmitButtonWhenStreetChanged() {
    this.streetInput.on('input', () => {
      this.disableFields([this.submitButton], true);
    });
  }

  hideValidCheckmarkWhenStreetChanged() {
    this.streetInput.on('input', () => {
      this.displayFields([this.inputStreetOkClass], 'none');
    });
  }

  validateAddressWhenTyping() {
    this.streetInput.on('input change', this.debounceValidation);
  }

  getDebounceValidateAddressFunction() {
    return _.debounce(() => {
      const address = this.getCurrentAddress();

      if (address.streetName && address.streetNumber) {
        this.validateAddress(address);
      } else {
        this.streetInptErrorMsgClass.hide();
        this.streetDropdownMismatchErrorMsgClass.hide();
        this.entireAddressErrorMsgClass.hide();
        this.streetInput.removeClass(this.inputErrorClass);
        this.errorMsg.hide();
      }
    }, 500);
  }

  getCurrentAddress() {
    const input = this.streetInput.val();
    const postalCode = this.postalCodeInput.val().trim();
    return { postalCode, ...this.parseStreetInput(input) };
  }

  parseStreetInput(value) {
    if (value) {
      const streetNumberRegex = /[0-9]+(-[0-9]+)?[A-Za-zåäöÅÄÖ]?(-[A-Za-zåäöÅÄÖ]+)?/; // Includes cases like 26a , 3-6 , 10a-b for the street number
      const numberMatch = value.match(streetNumberRegex);

      if (numberMatch) {
        const streetName = value.substring(0, numberMatch.index).trim();
        const streetNumber = numberMatch[0];
        const apartment = value.substring(numberMatch.index + streetNumber.length, value.length).trim();
        return { streetName, streetNumber, apartment };
      }
    }

    return null;
  }

  validateAddress(address) {
    this.newAddress = address;

    if (!this.stillValidating) {
      this.stillValidating = true;
      this.showStreetLoadingIcon();
      this.displayFields([this.inputStreetOkClass], 'none');
      this.validateNewAddress();
    }
  }

  validateNewAddress() {
    const address = this.newAddress;
    this.newAddress = null;
    if (address) {
      const receivedParametersForValidation = `${address.postalCode}-${address.streetName}-${address.streetNumber}-${address.apartment}`.trim();
      $.getJSON(
        encodeURI(
          `/.rest/availability/validateApartment?postalCode=${address.postalCode}&streetName=${address.streetName}&streetNumber=${address.streetNumber}&apartmentNumber=${address.apartment}`,
        ),
      )
        .done((data) => {
          if (data && data.response === true) {
            let sendSuccessMessageToAnalytics = false;
            this.streetInptErrorMsgClass.hide();
            this.streetDropdownMismatchErrorMsgClass.hide();
            this.entireAddressErrorMsgClass.hide();
            this.streetInput.removeClass(this.inputErrorClass);
            this.errorMsg.hide();
            this.generalErrorMsg.hide();
            this.streetInput.attr('aria-invalid', 'false');
            this.displayFields([this.inputStreetOkClass], 'inline-block');
            this.disableFields([this.submitButton], false);
            if (this.successParameterSentToAnalytics === null) {
              sendSuccessMessageToAnalytics = true;
              this.successParameterSentToAnalytics = receivedParametersForValidation;
            } else if (!(this.successParameterSentToAnalytics === receivedParametersForValidation)) {
              sendSuccessMessageToAnalytics = true;
            }
            const streetAddress = `${address.streetName} ${address.streetNumber} ${address.apartment}`.trim();
            $('.valid-street-address').text(streetAddress);
            if (sendSuccessMessageToAnalytics) {
              this.debounceFunction(() => {
                this.sendValidStreetAddressMesageToAnalytics(address.postalCode, address.streetName);
              }, 5000);
            }
          } else {
            if (data && data.response === false && data.invalidStreetNameAndNumber === true) {
              this.streetInptErrorMsgClass.hide();
              this.streetDropdownMismatchErrorMsgClass.show();
              this.entireAddressErrorMsgClass.hide();
              this.debounceFunction(() => {
                this.sendStreetAddressNotMatchingDropdownMesageToAnalytics(address.postalCode, address.streetName);
              }, 5000);
            } else if (data && data.invalidStreetNameAndNumber === false && (address.apartment === '')) {
              this.streetInptErrorMsgClass.show();
              this.streetDropdownMismatchErrorMsgClass.hide();
              this.entireAddressErrorMsgClass.hide();
              this.debounceFunction(() => {
                this.sendInvalidStreetAddressMesageToAnalytics(address.postalCode, address.streetName, address.streetNumber);
              }, 5000);
            } else {
              this.streetInptErrorMsgClass.hide();
              this.streetDropdownMismatchErrorMsgClass.hide();
              this.entireAddressErrorMsgClass.show();
              this.debounceFunction(() => {
                this.sendAddressNotFoundMesageToAnalytics(address.postalCode, address.streetName, address.streetNumber, address.apartment);
              }, 5000);
            }
            this.streetInput.attr('aria-invalid', 'true');
            this.streetInput.addClass(this.inputErrorClass);
            this.errorMsg.hide();
            this.generalErrorMsg.hide();
            this.disableFields([this.submitButton], true);
            this.displayFields([this.inputStreetOkClass], 'none');
          }
        })
        .fail((jqXHR, textStatus, error) => {
          this.streetInptErrorMsgClass.hide();
          this.streetDropdownMismatchErrorMsgClass.hide();
          this.entireAddressErrorMsgClass.hide();
          this.streetInput.removeClass(this.inputErrorClass);
          this.errorMsg.hide();
          this.generalErrorMsg.show();
          this.disableFields([this.submitButton], true);
          this.displayFields([this.inputStreetOkClass], 'none');
          this.sendFailedToValidateStreetAddressMessageToAnalytics(address.postalCode, address.streetName, error);
        })
        .always(() => {
          this.validateNewAddress();
        });
    } else {
      this.hideStreetLoadingIcon();
      this.stillValidating = false;
    }
  }

  showStreetLoadingIcon() {
    this.node.find('.availabilitysearch__street-input--icon-loading').show();
  }

  hideStreetLoadingIcon() {
    this.node.find('.availabilitysearch__street-input--icon-loading').hide();
  }

  bindEventListeners() {
    this.addPostalCodeChangeHandlers();
    this.animateInputLabelsOnCBlur();
    this.addSubmitButtonClickHandler();
    this.focusOnStreetWhenEnterIsClickedOnPostalCodeInput();
    this.submitWhenEnterIsClickedOnStreetInput();
  }

  submitWhenEnterIsClickedOnStreetInput() {
    this.streetInput.on('keydown', (evt) => {
      if (evt.key === 'Enter') {
        this.submitButton.click();
      }
    });
  }

  focusOnStreetWhenEnterIsClickedOnPostalCodeInput() {
    this.postalCodeInput.on('keydown', (evt) => {
      if (evt.key === 'Enter') {
        this.streetInput.focus();
      }
      if (this.resolvingPostalcode === true) {
        if (evt.keyCode === 9) {
          evt.preventDefault();
        }
      }
    });
  }

  moveToNextFocusableElementFromStreetInputField() {
    this.streetInput.on('keydown', (evt) => {
      if (evt.keyCode === 9) {
        evt.preventDefault();
        const isShiftPressed = evt.shiftKey;
        if (isShiftPressed) {
          this.postalCodeInput.focus();
        } else {
          const button = document.getElementById('availabilitysearch__submit');
          let nextElement;
          if (button.disabled) {
            nextElement = this.getNextFocusableElement(document.getElementById('availabilitysearch__focus-point'));
          } else {
            nextElement = button;
          }
          if (nextElement) {
            nextElement.focus();  // Focus the next element
          }
        }
      }
    });
  }

  getNextFocusableElement(currentElement) {
    let focusableElements = Array.from(document.querySelectorAll('input, button, select, #availabilitysearch__focus-point, textarea, a[href], [tabindex]:not([tabindex="-1"])'));
    let index = focusableElements.indexOf(currentElement);
    return focusableElements[index + 1];  // Return the next focusable element
  }

  addSubmitButtonClickHandler() {
    // Prevent using of AJAX in eShop's postback environment.
    // Instead use regular form submitting. EShop will wrap this component, and the whole page in a form.
    // EShop uses our javascript but a custom template in which they add this attribute.
    const inEshopMode = this.node.attr('data-eshop-mode') === 'true';

    if (inEshopMode) {
      return;
    }

    this.submitButton.on('click', () => {
      this.submitAvailabilitySearch();
    });
  }

  submitAvailabilitySearch() {
    if (!this.isDisabledField(this.submitButton)) {
      this.loadingAnimation.addClass(this.loadingAnimationVisibleClass);

      // Update the aria-live region to announce loading
      $('.loading-announcement').text('Tulokset latautuvat...');

      this.errorMsg.hide();
      this.generalErrorMsg.hide();
      this.disableFields([this.submitButton], true);
      this.callEshopAvailabilityApi();
    }
  }

  // Added a new Submit Method for Eshop API
  callEshopAvailabilityApi() {
    const eshopAvailabilityApiUrl = this.node.attr('data-eshopavailabilityapiurl');
    const address = this.getCurrentAddress();
    const postalCode = address.postalCode;
    const streetName = address.streetName;
    const streetNumber = address.streetNumber;
    const apartment = address.apartment;
    $.getJSON(
      `${eshopAvailabilityApiUrl}?PostalCode=${postalCode}&StreetName=${streetName}&StreetNumber=${streetNumber}&Apartment=${apartment}`,
    )
      .done((data) => {
        const fixedBroadbandAvailable = data.fixedBroadbandAvailable;
        if (fixedBroadbandAvailable) {
          const legacyEshopRedirectUrl = this.node.attr('data-eshopredirectformsubmiturl');
          this.eshopForm.attr('action', legacyEshopRedirectUrl);
        } else {
          const b2cEcommerceRedirectFormSubmitUrl = this.node.attr('data-b2cecommerceredirectformsubmiturl');
          this.eshopForm.attr('action', b2cEcommerceRedirectFormSubmitUrl);
        }
        this.displayFields([this.inputPostalOkClass], 'inline-block');

        this.setCookies(postalCode, streetName, streetNumber, apartment);
        this.eshopFormPostalCode.attr('value', postalCode);
        this.eshopFormStreetName.attr('value', streetName);
        this.eshopFormStreetNumber.attr('value', streetNumber);
        if (apartment !== undefined) {
          this.eshopFormApartment.attr('value', apartment);
        } else {
          this.eshopFormApartment.attr('value', '');
        }
        this.eshopForm.submit();
      })
      .fail(() => {
        this.generalErrorMsg.show();
        setTimeout(() => {
          this.loadingAnimation.removeClass(this.loadingAnimationVisibleClass);
        }, 1000);
      })
      .always(() => {
        this.disableFields([this.submitButton], false);
      });
  }

  animateInputLabelsOnCBlur() {
    this.inputs.blur((evt) => {
      const input = $(evt.target);

      if (input.val() !== '') {
        input.addClass('has-value');
      } else {
        input.removeClass('has-value');
      }
    });
  }

  addPostalCodeChangeHandlers() {
    this.postalCodeInput.on('input change', (evt) => {
      if (this.resolvingPostalcode === true) {
        return;
      }

      this.resolvingPostalcode = true;
      const postalCode = $(evt.target).val().trim();

      if (postalCode.length === 0) {
        this.streetInptErrorMsgClass.hide();
        this.streetDropdownMismatchErrorMsgClass.hide();
        this.entireAddressErrorMsgClass.hide();
        this.errorMsg.hide();
      }

      if (postalCode === this.validatedPostalCode) {
        this.resolvingPostalcode = false;
        return;
      }

      // Disable other fields
      this.disableFields([this.streetInput, this.submitButton], true);
      this.displayFields([this.inputPostalOkClass, this.inputStreetOkClass], 'none');
      this.postalCodeInput.removeClass(this.inputErrorClass);
      this.displayFields([this.postalCodeInputErrorMsgClass], 'none');

      const postalCodeLooksValid = postalCode.length === 5 && postalCode.match(this.isNumber) && postalCode.indexOf(' ') === -1;

      if (postalCodeLooksValid) {
        $.getJSON(`/.rest/availability/streetmap/${postalCode}`)
          .done((data) => {
            if (_.size(data.response) > 0) {
              this.displayFields([this.inputPostalOkClass], 'inline-block');
              this.errorMsg.hide();
              this.addStreetNameOptionsToAutoComplete(data.response);
              this.sendValidPostalCodeMessageToAnalytics(postalCode);
              this.disableFields([this.streetInput], false);
              $('.valid-postal-code').text(postalCode);
            } else {
              this.postalCodeInput.addClass(this.inputErrorClass);
              this.displayFields([this.postalCodeInputErrorMsgClass], 'inline-block');
              this.sendInvalidPostalCodeMessageToAnalytics(postalCode);
              this.disableFields([this.streetInput], true);
            }

            this.validatedPostalCode = postalCode;
          })
          .fail((jqXHR, textStatus, error) => {
            this.postalCodeInput.addClass(this.inputErrorClass);
            this.displayFields([this.postalCodeInputErrorMsgClass], 'inline-block');
            this.generalErrorMsg.show();

            setTimeout(() => {
              this.loadingAnimation.removeClass(this.loadingAnimationVisibleClass);
            }, 1000);

            this.sendFailedToValidatePostalCodeMessageToAnalytics(postalCode, error);
            this.disableFields([this.streetInput], true);
          })
          .always(() => {
            // This can be run again
            this.resolvingPostalcode = false;
          });
      } else {
        // At this point the user has attempted to write a postal code of at least 5 chars but it's not valid
        if (postalCode.length >= 5) {
          this.postalCodeInput.addClass(this.inputErrorClass);
          this.displayFields([this.postalCodeInputErrorMsgClass], 'inline-block');
          this.sendInvalidPostalCodeMessageToAnalytics(postalCode);
        }
        this.validatedPostalCode = postalCode;
        this.resolvingPostalcode = false;
      }
    });
  }

  sendValidStreetAddressMesageToAnalytics(postalCode, streetName) {
    sendEventToGoogleAnalytics(
      {
        event: 'HBB availability search',
        eventCategory: 'HBB availability search',
        eventAction: 'Validation success - Valid street address',
        eventLabel: `${postalCode} ${streetName}`,
      },
    );
  }

  sendStreetAddressNotMatchingDropdownMesageToAnalytics(postalCode, streetName) {
    sendEventToGoogleAnalytics(
      {
        event: 'HBB availability search',
        eventCategory: 'HBB availability search',
        eventAction: 'Validation error - Street address not matching drop-down',
        eventLabel: `${postalCode} ${streetName}`,
      },
    );
  }

  sendAddressNotFoundMesageToAnalytics(postalCode, streetName, streetNumber, apartmentNumber) {
    sendEventToGoogleAnalytics(
      {
        event: 'HBB availability search',
        eventCategory: 'HBB availability search',
        eventAction: 'Validation error - Address not found',
        eventLabel: `${postalCode} ${streetName} ${streetNumber} ${apartmentNumber}`,
      },
    );
  }

  sendInvalidStreetAddressMesageToAnalytics(postalCode, streetName, streetNumber) {
    sendEventToGoogleAnalytics(
      {
        event: 'HBB availability search',
        eventCategory: 'HBB availability search',
        eventAction: 'Validation error - Invalid street address',
        eventLabel: `${postalCode} ${streetName} ${streetNumber}`,
      },
    );
  }

  sendFailedToValidateStreetAddressMessageToAnalytics(postalCode, streetName, error) {
    sendEventToGoogleAnalytics(
      {
        event: 'HBB availability search',
        eventCategory: 'HBB availability search',
        eventAction: 'Validation error - Failed to validate street address',
        eventLabel: `${postalCode} ${streetName}, ${error}`,
      },
    );
  }

  sendValidPostalCodeMessageToAnalytics(postalCode) {
    sendEventToGoogleAnalytics(
      {
        event: 'HBB availability search',
        eventCategory: 'HBB availability search',
        eventAction: 'Validation success - Valid postal code',
        eventLabel: postalCode,
      },
    );
  }

  sendInvalidPostalCodeMessageToAnalytics(postalCode) {
    sendEventToGoogleAnalytics(
      {
        event: 'HBB availability search',
        eventCategory: 'HBB availability search',
        eventAction: 'Validation error - Invalid postal code',
        eventLabel: postalCode,
      },
    );
  }

  sendFailedToValidatePostalCodeMessageToAnalytics(postalCode, error) {
    sendEventToGoogleAnalytics(
      {
        event: 'HBB availability search',
        eventCategory: 'HBB availability search',
        eventAction: 'Validation error - Failed to validate postal code',
        eventLabel: `${postalCode}, ${error}`,
      },
    );
  }

  addStreetNameOptionsToAutoComplete(streetNamesJson) {
    const result = [];

    _.each(streetNamesJson, (streetNumbers, address) => {
      _.each(streetNumbers, (streetNumber) => {
        result.push({
          label: `${address} ${streetNumber}`,
          value: { street: address, number: streetNumber },
        });
      });
    });

    this.ACStreetInput.setOptionList(result);
  }

  displayItems(fields, visibility) {
    _.each(fields, (field) => {
      this.node.find(field).css('display', visibility);
    });
  }

  disableFields(fields, disable) {
    _.each(fields, (field) => {
      this.node.find(field).prop('disabled', disable);
    });
  }

  isDisabledField(field) {
    return field.prop('disabled');
  }

  displayFields(fields, displayValue) {
    _.each(fields, (field) => {
      this.node.find(field).css('display', displayValue);
    });
  }

  resolveStreetNumbers(address, streetNumbers) {
    const result = [];

    _.each(streetNumbers, (streetNumber) => {
      result.push({
        label: `${address} ${streetNumber}`,
        value: { street: address, number: streetNumber },
      });
    });

    return result;
  }

  setCookies(postalCode, streetName, streetNumber, apartment) {
    const addressCookie = Cookies.get(this.cookieName);

    const addressPresentInCookie = this.checkIfAddressIsAlreadyPresentInCookie(
      addressCookie,
      postalCode,
      streetName,
      streetNumber,
      apartment,
    );

    const shouldCreateNewCookie = !addressCookie || !addressPresentInCookie;

    if (shouldCreateNewCookie) {
      this.setAddressCookie(postalCode, streetName, streetNumber, apartment);
    }
  }

  setAddressCookie(postalCode, streetName, streetNumber, apartment) {
    const expiry = parseInt(this.node.attr('data-cookieExpiryTime'), 10);

    const cookieValue = {
      postalCode,
      street: streetName,
      number: streetNumber,
      apartment,
    };

    Cookies.set(this.cookieName, JSON.stringify(cookieValue), { expires: expiry });
  }

  checkIfAddressIsAlreadyPresentInCookie(addressCookie, postalCode, streetName, streetNumber, apartment) {
    if (addressCookie) {
      const address = JSON.parse(addressCookie);

      return (
        address.postalCode === postalCode &&
        address.street === streetName &&
        address.number === streetNumber &&
        address.apartment === apartment
      );
    }

    return false;
  }

  postFormToEshop(orderUrl) {
    const params = this.readQueryString(orderUrl);
    this.eshopFormPostalCode.attr('value', params.PostalCode);
    this.eshopFormStreetName.attr('value', params.StreetName);
    this.eshopFormStreetNumber.attr('value', params.StreetNumber);

    if (params.Apartment !== undefined) {
      this.eshopFormApartment.attr('value', params.Apartment);
    } else {
      this.eshopFormApartment.attr('value', '');
    }

    this.eshopForm.submit();
  }

  readQueryString(url) {
    const a = url.split(/\?/);
    const b = a[1].split('&');
    const c = {};

    for (let i = 0; i < b.length; i += 1) {
      const d = b[i].split('=');
      c[d[0]] = d[1];
    }

    return c;
  }

  bindAutocomplete() {
    this.ACStreetInput = new Autocomplete();
    this.ACStreetInput.configure({ fuzzySearch: false, sortByRanking: false, ignoreWhitespace: false, addWhiteSpaceToSelectedValue: true });
    this.ACStreetInput.build(this.streetInput);
    // Wait for the listbox to be created and then set the ID
    setTimeout(() => {
      const listbox = document.querySelector('.ppr-autocomplete__list');
      if (listbox) {
        listbox.id = 'street-listbox'; // Assign an ID to the listbox
        this.streetInput.attr('aria-controls', 'street-listbox'); // Set the aria-controls attribute on the input element
      }
    }, 0);
    this.ACStreetInput.eventBus.subscribe(this, 'select', this.debounceValidation);
  }

  populateDataFromCookie() {
    const addressCookie = Cookies.get(this.cookieName);

    if (addressCookie) {
      const address = JSON.parse(addressCookie);
      const changeEvent = $.Event('change');
      const enterEvent = $.Event('keydown', { which: 13 });

      this.postalCodeInput.val(address.postalCode);
      this.postalCodeInput.trigger(changeEvent);

      const streetNumber = address.number ? ` ${address.number}` : '';
      const apartment = address.apartment ? ` ${address.apartment}` : '';
      this.streetInput.val(`${address.street}${streetNumber}${apartment}`);
      this.postalCodeInput.trigger(enterEvent);

      this.ACStreetInput.eventBus.publish('select', address);
      this.ACStreetInput.eventBus.publish('enter');
    }
  }

  debounceFunction(func, delay) {
    clearTimeout(this.streetErrorTimerId);
    this.streetErrorTimerId = setTimeout(func, delay);
  }
}